/// <reference path="../global.d.ts" />

// Configurações de runtime usando variáveis de ambiente injetadas em tempo de execução
export const URL_API = window._env_?.API_URL ?? 'https://localhost:44344/api';
export const HOST = window._env_?.HOST ?? 'http://localhost:3000';

console.log({ URL_API });
console.log({ HOST });
